import * as React from 'react';

import { format } from 'date-fns';

// Material-UI
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import {
  MATERIALUI_DIALOG_REASON_BACKDROPCLICK,
  MATERIALUI_DIALOG_REASON_ESCKEYDOWN,
} from '../global';

// Styles
import { useTheme } from '@mui/material/styles';

// Redux
import { useAppSelector } from '../hooks/UseReduxState'
import { getCopyright, getReleaseDate, getVersion } from '../../redux/appSlice'

export interface AboutProps {
  open: boolean;
  onClose: () => void;
}
const About: React.FC<AboutProps> = (props) => {

  // Redux
  const rawDate = useAppSelector(getReleaseDate);
  const copyright: string = useAppSelector(getCopyright);
  const releaseDate: string = rawDate
    ? format(new Date(rawDate), 'MM/dd/yyyy')
    : 'n/a';
  const version: string = useAppSelector(getVersion);

  // #region Styles

  const theme = useTheme();
  const styles = {
    closeButton: {
      margin: theme.spacing(0, 1, 1, 0)
    }
  };

  // #endregion

  /*
* Event handler for Material-UI onClose
*/
  const handleClose = (event: object, reason: string) => {
    if ((reason === MATERIALUI_DIALOG_REASON_BACKDROPCLICK) || (reason === MATERIALUI_DIALOG_REASON_ESCKEYDOWN)) {
      return;
    }
  };

  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      disableEscapeKeyDown={true}
    >
      <DialogTitle>About the MSC Website</DialogTitle>
      <DialogContent>
        <Grid container direction="column">
          {/* Option 1: gutterBottom adds a theme-standard bottom margin */}
          <Typography variant="body1" gutterBottom>
            {`Version ${version} (${releaseDate})`}
          </Typography>

          <Typography variant="body1" gutterBottom>
            The Montclair Ski Club website was created by the volunteers of the MSC website team.
          </Typography>

          {/* Option 2: Use sx for explicit control (mb: 2 is usually 16px) */}
          <Typography variant="body1" sx={{ mb: 2 }}>
            &copy;{copyright} Montclair Ski Club, Inc.
          </Typography>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose} variant="outlined" color="primary" sx={styles.closeButton}>Close</Button>
      </DialogActions>
    </Dialog >
  );

}

export default About;
